<template>
    <div class="list-icon">
        
        <div v-if="TipoV == 1">
            <div class="card card-sombra" v-if="(form.TipoTema == 'TABLA')">
                <div class="card-body">
                    <h4 v-show="(form.Titulo !='')" class="text-center mb-3 color_Azul family-01">{{form.Titulo}}</h4>
                    <div class="row form-group justify-content-center">
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <h5 v-show="(form.Subtitulo !='')" class="text-center mb-1 color_Azul">{{form.Subtitulo}}</h5>
                        </div>
                    </div>
                    <!--<h5 v-show="(form.Subtitulo !='')" class="text-center mb-1 color_Azul">{{form.Subtitulo}}</h5>-->
                    <div v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                        <div v-show="(detalle.Descripcion !='')" v-html="detalle.Descripcion"></div>
                        <p v-show="(detalle.TituloTabla !='')" class="text-center"><b>{{detalle.TituloTabla}}</b></p>

                        <div class="table-responsive">
                            <table class="table  table-lenguas">
                                <thead>
                                    <tr>
                                        <th class="text-center">{{detalle.Titulo1}}</th>
                                        <th class="text-center">{{detalle.Titulo2}}</th>
                                        <th class="text-center" v-show="(detalle.Tipo!='2X2')" :colspan="(detalle.Tipo=='3X3')?1:3">{{detalle.Titulo3}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(buff, indext) in detalle.detalletabla" :key="indext">
                                            
                                        <td class="text-center" v-if="buff.Camp1 == 'NA'" ></td>
                                        <td class="text-center" v-else  >{{buff.Camp1}}</td>


                                        <td class="text-center" v-if="buff.Camp1 == 'NA'" ><b>{{buff.Camp2}}</b></td>
                                        <td class="text-center" v-else >{{buff.Camp2}}</td>


                                        <td  v-if="buff.Camp1 == 'NA'" v-show="(detalle.Tipo!='2X2')">
                                            <b>{{buff.Camp3}}</b>
                                        </td>
                                        <td class="text-center" v-else  v-show="(detalle.Tipo!='2X2')">
                                            {{buff.Camp3}}
                                        </td>


                                        <td  v-if="buff.Camp1 == 'NA'" v-show="(detalle.Tipo=='3X5')">
                                            <b>{{buff.Camp4}}</b>
                                        </td>
                                        <td class="text-center" v-else v-show="(detalle.Tipo=='3X5')">
                                            {{buff.Camp4}}
                                        </td>

                                        <td  v-if="buff.Camp1 == 'NA'" v-show="(detalle.Tipo=='3X5')">
                                            <b>{{buff.Camp5}}</b>
                                        </td>
                                        <td class="text-center" v-else v-show="(detalle.Tipo=='3X5')">
                                            {{buff.Camp5}}
                                        </td>
                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p v-show="(detalle.HoraIni != '')" class="text-center"><b>{{detalle.HoraIni}}</b></p>
                        <p v-show="(detalle.HoraFin != '')" class="text-center"><b>{{detalle.HoraFin}}</b></p>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <h3 class="color_Azul family-01 mb-3" v-if="(form.Titulo !='')">{{form.Titulo}}</h3>
            <hr class="divider-02 hr-sm-left-0 bg-color" v-if="(form.Titulo !='')">
            <h6 class="mb-3 color_Azul" v-if="(form.Subtitulo !='')">
                {{form.Subtitulo}}
            </h6>
            <div v-for="(detalle,key3) in form.detContenidoTema" :key="key3">
                
                <p class="text-justify list-icon" v-html="detalle.Descripcion"></p>
                
                <div class="row justify-content-center" v-if="(form.TipoTema == 'TABLA')">
                    <div :class="{
                        'col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5':detalle.Nombre =='CH',
                        'col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8':detalle.Nombre == 'MD', 
                        'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12':detalle.Nombre == 'LG'
                    }">
                        <div class="card card-lenguas">
                            <div class="card-body">
                                <table class="table table-lg table-lenguas">
                                    <thead>
                                        <tr v-if="detalle.TituloTabla!=''">
                                            <th v-if="(detalle.Tipo=='2X2')" colspan="2" class="text-center">
                                                {{detalle.TituloTabla}}
                                            </th>
                                            <th v-else-if="(detalle.Tipo=='3X3')" colspan="3" class="text-center">
                                                {{detalle.TituloTabla}}
                                            </th>
                                            <th v-else-if="(detalle.Tipo=='3X5')" colspan="5" class="text-center">
                                                {{detalle.TituloTabla}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th :class="'text-'+detalle.IconoIni">{{detalle.Titulo1}}</th>
                                            <th :class="'text-'+detalle.IconoIni">{{detalle.Titulo2}}</th>
                                            <th :class="'text-'+detalle.IconoIni" v-show="(detalle.Tipo!='2X2')" :colspan="(detalle.Tipo=='3X3')?1:3">
                                                {{detalle.Titulo3}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(buff, indext) in detalle.detalletabla" :key="indext">
                                            <td :class="'text-'+detalle.IconoFin">{{(buff.Camp1 == 'NA')?'':buff.Camp1}}</td>
                                            <td :class="'text-'+detalle.IconoFin">
                                                <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp2}}</b></span>
                                                <span v-else>{{buff.Camp2}}</span>
                                            </td>
                                            <td :class="'text-'+detalle.IconoFin" v-show="(detalle.Tipo!='2X2')">
                                                <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp3}}</b></span>
                                                <span v-else>{{buff.Camp3}}</span>
                                            </td>
                                            <td :class="'text-'+detalle.IconoFin" v-show="(detalle.Tipo=='3X5')">
                                                <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp4}}</b></span>
                                                <span v-else>{{buff.Camp4}}</span>
                                            </td>
                                            <td :class="'text-'+detalle.IconoFin" v-show="(detalle.Tipo=='3X5')">
                                                <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp5}}</b></span>
                                                <span v-else>{{buff.Camp5}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br>
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                        {{detalle.HoraIni}}
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                        {{detalle.HoraFin}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['value','RutaFile','listIconos','index','Tipo'],
    data() {
        return {
            form:this.value,
            TipoV:this.Tipo
        }
    },methods: {
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },
}
</script>